import { CartType, RestCalculateResponse, SuccessResponse } from "interfaces";
import request from "./request";

const cartService = {
  store: (data?: any): Promise<SuccessResponse<CartType>> =>
    request.post(`/dashboard/user/cart`, data),
  get: (params?: any): Promise<SuccessResponse<CartType>> =>
    request.get(`/dashboard/user/cart`, { params }),
  deleteCartProducts: (data: any) =>
    request.delete(`/dashboard/user/cart/product/delete`, { data }),
  delete: (data: any) =>
    request.delete(`/dashboard/user/cart/delete`, {
      data,
    }),
  insert: (data: any): Promise<SuccessResponse<CartType>> =>
    request.post(`/dashboard/user/cart/insert-product`, data),
  open: (data: any) => request.post(`/dashboard/user/cart/open`, data),
  join: (data: any) => request.post(`/rest/cart/open`, data),
  restCalculate: async (
    params?: any,
  ): Promise<SuccessResponse<RestCalculateResponse>> =>
    request
      .get("/rest/order/products/calculate", { params })
      .then((res) => res?.data),
  getDeliveryOptions: (params?: any) =>
    request.get("/rest/delivery-options", { params }),
};

export default cartService;
